<template>
    <SelectDropDown
            :id="id"
            :name="name"
            @selection-change="generalStatusSelected"
            :options="professions"
            :defaultSelected="professions[0]"
    />
</template>

<script>
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import {mapGetters} from 'vuex';

    export default {
        name: "TeamProfessionDropdown",
        components: {SelectDropDown},
        props: {
            id: String,
            name: String
        },
        created() {
            this.setProfessions();
        },
        data() {
            return {
                professions: []
            }
        },
        methods: {
            generalStatusSelected(value) {
                this.$emit('selection-change', {
                    id: value.dropDownId,
                    isDropdown: true,
                    name: value.name,
                    label: value.label,
                    currentValue: value.currentValue.id === 'none' ? '' : value.currentValue.name,
                    oldValue: value.oldValue
                });
            },
            setProfessions() {
                this.professions = [];
                this.professions.push({
                    id: 'none',
                    name: '(всички)'
                });
                this.teamProfessions.forEach(profession => {
                    const tempProfession = profession;
                    tempProfession.name = profession.professionName;
                    tempProfession.id = profession.professionId;
                    this.professions.push(tempProfession)
                });
            }
        },
        computed: {
            ...mapGetters(['teamProfessions'])
        },
        watch: {
            teamProfessions: {
                handler() {
                    this.setProfessions();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
